import config from './App.json';

class AppConfig {
    constructor() {
      this._appInfo = config.appInfo;
      this._setting = config.setting;
    }

    get appInfo() {
      return this._appInfo;
    }

    getSetting(vip) {
      var setting = this._setting.default;
      if (vip > 0) {
        setting = {...setting, ...this._setting.pro};
      }
      if (vip > 1) {
        setting = {...setting, ...this._setting.premium};
      }
      return setting;
    }
}

const appConfig = new AppConfig();
export default appConfig;